export const MAIN_BANNER_LOGO =
  "https://static.wixstatic.com/media/a66d89_b1f8d29e7a6646159e51d74f246d23c8~mv2.png/v1/fill/w_281,h_336,al_c,q_85,usm_4.00_1.00_0.00,enc_auto/a66d89_b1f8d29e7a6646159e51d74f246d23c8~mv2.png 1x, https://static.wixstatic.com/media/a66d89_b1f8d29e7a6646159e51d74f246d23c8~mv2.png/v1/fill/w_562,h_672,al_c,q_90,usm_4.00_1.00_0.00,enc_auto/a66d89_b1f8d29e7a6646159e51d74f246d23c8~mv2.png 2x";

export const VEHICLES_DATA = [
  {
    image:
      "https://static.wixstatic.com/media/a66d89_e5779270cb7e4940a51d29fb788459b7~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_e5779270cb7e4940a51d29fb788459b7~mv2.jpeg",
    name: "Electric Three-Wheeler 1",
    price: 399742,
    outOfStock: false,
    kmsRun: 8776,
    regnYear: 2024,
    loadCapacity: "750kg",
    vehicleId: 1,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_3102811ca07c4e2a9a4d89dd3e547393~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_3102811ca07c4e2a9a4d89dd3e547393~mv2.jpeg",
    name: "PIAGGIO - Ape E-xtra fx Max(PU)",
    price: 329282,
    outOfStock: false,
    isNew: false,
    kmsRun: 4330,
    regnYear: 2023,
    loadCapacity: "700 kg",
    vehicleId: 2,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_188d0ee443b24de3998f7956901a662c~mv2.jpg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_188d0ee443b24de3998f7956901a662c~mv2.jpg",
    name: "PIAGGIO - Ape E-xtra fx",
    price: 329282,
    outOfStock: true,
    kmsRun: 18764,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 3,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_de41d5974bf248a6a6ecd433f936b54f~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_de41d5974bf248a6a6ecd433f936b54f~mv2.jpeg",
    name: "PIAGGIO - Ape E-xtra fx Max",
    price: 321334,
    outOfStock: false,
    isNew: false,
    kmsRun: 8467,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 4,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_2b376832cc7e4e77ba6a5504518a2e51~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_2b376832cc7e4e77ba6a5504518a2e51~mv2.jpeg",
    name: "PIAGGIO - Ape E-xtra fx Max",
    price: 320013,
    outOfStock: false,
    kmsRun: 5529,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 5,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_2240d12582eb494998b0ceb5faa735d0~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_2240d12582eb494998b0ceb5faa735d0~mv2.jpeg",
    name: "PIAGGIO - Ape E-xtra fx Max",
    price: 325541,
    outOfStock: false,
    isNew: false,
    kmsRun: 52,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 6,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_3d1ef1e66f8d40e4947484e7ffb243af~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_3d1ef1e66f8d40e4947484e7ffb243af~mv2.jpeg",
    name: "PIAGGIO - Ape E-xtra fx Max",
    price: 331380,
    outOfStock: false,
    kmsRun: 133,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 7,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_8c2b0133a43f42efbe31b1c2e3bab147~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_8c2b0133a43f42efbe31b1c2e3bab147~mv2.jpeg",
    name: "EULER - Hiload DVXR13",
    price: 411000,
    outOfStock: false,
    isNew: false,
    kmsRun: 321,
    regnYear: 2024,
    loadCapacity: "750kg",
    vehicleId: 8,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_79b699c055ff455c9e8b790df872ba5a~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_79b699c055ff455c9e8b790df872ba5a~mv2.jpeg",
    name: "PIAGGIO - Ape E-xtra fx Max",
    price: 366398,
    outOfStock: true,
    kmsRun: 565,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 9,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_af2e01c6a760489083b3cf5b1498c358~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_af2e01c6a760489083b3cf5b1498c358~mv2.jpeg",
    name: "MAHINDRA - TREO ZOR",
    price: 330312,
    outOfStock: false,
    isNew: false,
    kmsRun: 3206,
    regnYear: 2023,
    loadCapacity: "750kg",
    vehicleId: 10,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_c1db8f21ff5742ffa6f97ca54e61f845~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_c1db8f21ff5742ffa6f97ca54e61f845~mv2.jpeg",
    name: "MAHINDRA - TREO ZOR",
    price: 340126,
    outOfStock: false,
    kmsRun: 6556,
    regnYear: 2022,
    loadCapacity: "750kg",
    vehicleId: 11,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_47be22bbf6a04f539e1aa43f6453668a~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_47be22bbf6a04f539e1aa43f6453668a~mv2.jpeg",
    name: "MAHINDRA - TREO PLUS SFT SM",
    price: 330596,
    outOfStock: false,
    isNew: false,
    kmsRun: 4453,
    regnYear: 2024,
    loadCapacity: "750kg",
    vehicleId: 12,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_29b6ca23320d4461839c9badd99cb1b4~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_29b6ca23320d4461839c9badd99cb1b4~mv2.jpeg",
    name: "MAHINDRA - TREO PLUS SFT SM",
    price: 326302,
    outOfStock: false,
    kmsRun: 8606,
    regnYear: 2024,
    loadCapacity: "750kg",
    vehicleId: 13,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_3f237184391b487eb2f89922ee1347a2~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_3f237184391b487eb2f89922ee1347a2~mv2.jpeg",
    name: "Euler - Hiload DVXR13",
    price: 9000,
    outOfStock: true,
    isNew: false,
    kmsRun: 22224,
    regnYear: 2023,
    loadCapacity: "750kg",
    vehicleId: 14,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_fbcbe7f0131a4d91a7c51dcfdd6674b0~mv2.jpg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_fbcbe7f0131a4d91a7c51dcfdd6674b0~mv2.jpg",
    name: "PIAGGIO - Ape E-xtra fx Max",
    price: 384251,
    outOfStock: false,
    kmsRun: 51,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 15,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_e518f41a562e49ccb3998f8ff44ada3c~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_e518f41a562e49ccb3998f8ff44ada3c~mv2.jpeg",
    name: "ALTIGREEN - NeEV",
    price: 400400,
    outOfStock: false,
    isNew: true,
    kmsRun: 4000,
    regnYear: 2023,
    loadCapacity: "750kg",
    vehicleId: 16,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_bd22375e6fb445d4924f529adae9eee8~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_bd22375e6fb445d4924f529adae9eee8~mv2.jpeg",
    name: "ALTIGREEN - NeEV",
    price: 337472,
    outOfStock: false,
    isNew: true,
    kmsRun: 10736,
    regnYear: 2023,
    loadCapacity: "750kg",
    vehicleId: 17,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_c0fbbf8bc8e54f929a7825d7b5e82403~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_c0fbbf8bc8e54f929a7825d7b5e82403~mv2.jpeg",
    name: "MAHINDRA - TREO ZOR",
    price: 241428,
    outOfStock: false,
    isNew: true,
    kmsRun: 15679,
    regnYear: 2022,
    loadCapacity: "750kg",
    vehicleId: 18,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_bf617a03afc34353ae742b0aa00941e0~mv2.jpg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_bf617a03afc34353ae742b0aa00941e0~mv2.jpg",
    name: "PIAGGIO-Ape E-xtra fx Max",
    price: 8000,
    outOfStock: true,
    isNew: true,
    kmsRun: 1546,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 19,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_14b6fc7b5ac04150bc2d4860860fff56~mv2.jpg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_14b6fc7b5ac04150bc2d4860860fff56~mv2.jpg",
    name: "MAHINDRA - TREO ZOR",
    price: 257334,
    outOfStock: false,
    isNew: true,
    kmsRun: 18450,
    regnYear: 2022,
    loadCapacity: "750kg",
    vehicleId: 20,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_9017aeb559b44bee8246743ea931975e~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_9017aeb559b44bee8246743ea931975e~mv2.jpeg",
    name: "MAHINDRA - TREO ZOR",
    price: 238375,
    outOfStock: false,
    isNew: true,
    kmsRun: 30430,
    regnYear: 2022,
    loadCapacity: "750kg",
    vehicleId: 21,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_baa5444171784344b5ea40af901f0359~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_baa5444171784344b5ea40af901f0359~mv2.jpeg",
    name: "PIAGGIO-Ape E-xtra fx Max",
    price: 257334,
    outOfStock: true,
    isNew: true,
    kmsRun: 18450,
    regnYear: 2022,
    loadCapacity: "750kg",
    vehicleId: 22,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_bea7d199113a4acf971ebdd2cc00d189~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_bea7d199113a4acf971ebdd2cc00d189~mv2.jpeg",
    name: "PIAGGIO-Ape E-xtra fx Max",
    price: 217438,
    outOfStock: true,
    isNew: true,
    kmsRun: 2345,
    regnYear: 2022,
    loadCapacity: "700kg",
    vehicleId: 23,
  },
  {
    image:
      "https://static.wixstatic.com/media/a66d89_fbcfc2bc6c074af9883e38e34cb00aaf~mv2.jpeg/v1/fill/w_248,h_248,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/a66d89_fbcfc2bc6c074af9883e38e34cb00aaf~mv2.jpeg",
    name: "PIAGGIO-Ape E-xtra fx Max",
    price: 360785,
    outOfStock: false,
    isNew: true,
    kmsRun: 192,
    regnYear: 2023,
    loadCapacity: "700kg",
    vehicleId: 24,
  },

  // Add more vehicles as needed
];

export const OUR_MARKET_REACH_DATA = [
  {
    name: "Karnataka",
    image:
      "https://static.wixstatic.com/media/a66d89_422432b62783466eafa3e3e6a79ffb33~mv2.jpeg",
  },
  {
    name: "Maharashtra",
    image:
      "https://static.wixstatic.com/media/a66d89_25ad559fb502431aab85c24f2ed35e11~mv2.jpg",
  },
  {
    name: "Delhi",
    image:
      "https://static.wixstatic.com/media/a66d89_44f2bb5de8844dd08a00477d53823540~mv2.jpg",
  },
  {
    name: "Tamil Nadu",
    image:
      "https://static.wixstatic.com/media/a66d89_719deb8a8cea4d89b284746bffbba1d9~mv2.jpeg",
  },
  {
    name: "Telangana",
    image:
      "https://static.wixstatic.com/media/a66d89_a1d20e74a8354f2ba6b1bdac29efbf77~mv2.jpeg",
  },
];

export const WHY_INNOVOLT_DATA = [
  {
    icon: "https://assets.turnoclub.com/developer/offer-turno-images/S3/innovolt/svg1.jpg",
    title: "200+ points quality check",
  },
  {
    icon: "https://assets.turnoclub.com/developer/offer-turno-images/S3/innovolt/svg2.jpg",
    title: "Free document transfer",
  },
  {
    icon: "https://assets.turnoclub.com/developer/offer-turno-images/S3/innovolt/svg3.jpg",
    title: "3 years battery warranty",
  },
  {
    icon: "https://assets.turnoclub.com/developer/offer-turno-images/S3/innovolt/svg4.jpg",
    title: "Free doorstep delivery",
  },
];

export const SALES_TO_SATISIFACTION_DATA = [
  {
    title: "Vehicles Sold",
    count: "1200 +",
  },
  {
    title: "Inspections",
    count: "3500+",
  },
  {
    title: "Customer Rating",
    count: "4.8",
  },
];

export const SHOW_ROOMS_LOCATIONS_INFO = [
  {
    title: "Innovolt Bangalore Location",
    imageUrl:
      "https://assets.turnoclub.com/developer/innovolt/location_images/bangalore-location-image.webp",
    description:
      "INTACT AUTOPARC, K Jayanna Farm House, Pattanagere Village, Raja Rajeswari Nagar, Bangalore, Karnataka - 560098",
    openHours: "10:00 AM - 08:00 PM",
    whatsappLink:
      "https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-icon.svg",
  },
  {
    title: "Innovolt Hyderabad Location",
    imageUrl:
      "https://assets.turnoclub.com/developer/innovolt/location_images/hyderabad-location-image.webp",
    description:
      "M Suresh Reddy Parking Yard, H.No-8-7-196, Samatha Nagar, Near Ghorinagar Masjid, Old Bowenpally, Secunderabad - 500011",
    openHours: "09:00 AM - 07:00 PM",
    whatsappLink:
      "https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-icon.svg",
  },
  {
    title: "Innovolt Pune Location",
    imageUrl:
      "https://assets.turnoclub.com/developer/innovolt/location_images/pune-location-image.webp",
    description:
      "Suryoday Yards Private Limited, Gate No. 231/3B/8, 156/2K Wakad, Opp. Indira College, Mulshi, Pune - 411057",
    openHours: "07:00 AM - 05:00 PM",
    whatsappLink:
      "https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-icon.svg",
  },
  {
    title: "Innovolt Chennai Location",
    imageUrl:
      "https://assets.turnoclub.com/developer/innovolt/location_images/chennai-location-image.webp",
    description:
      "Emerald Parking Yard Pvt Ltd, No 12 Mettu Street, Subbaiah Nagar, Iyyapanthangal, Chennai - 600077",
    openHours: "11:00 AM - 09:00 PM",
    whatsappLink:
      "https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-icon.svg",
  },
  {
    title: "Innovolt Delhi Location",
    imageUrl:
      "https://assets.turnoclub.com/developer/innovolt/location_images/delhi-location-image.webp",
    description:
      "Shri Balaji Farm House, Maksoodabad Colony, Nazafgarh Nangloi Road, Delhi - 110043",
    openHours: "11:00 AM - 09:00 PM",
    whatsappLink:
      "https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-icon.svg",
  },
  {
    title: "Innovolt Lucknow Location",
    imageUrl:
      "https://assets.turnoclub.com/developer/innovolt/location_images/lucknow-location-image.webp",
    description:
      "V K Motors, 853-854, Renduva Palhari, Alipur, Chinhut Dewa Road, Lucknow - 225301",
    openHours: "07:00 AM - 05:00 PM",
    whatsappLink:
      "https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-icon.svg",
  },
  {
    title: "Innovolt Kanpur Location",
    imageUrl:
      "https://assets.turnoclub.com/developer/innovolt/location_images/kanpur-location-image.webp",
    description:
      "Kanpur Security and Services, Pakri, Kishan Nagar, Kanpur Nagar, Uttar Pradesh - 208001",
    openHours: "08:00 AM - 06:00 PM",
    whatsappLink:
      "https://assets.turnoclub.com/developer/innovolt/icons/whatsapp-icon.svg",
  },
];
